<tt-page class="col-xs-12 col-md-4 p-5">
    <tt-card>
        <tt-button-goto ttText="businesss_new" ttGoto="business" [ttGotoParms]="{ business_id: '0' }" ttIcon="far fa-plus"></tt-button-goto>
    </tt-card>

    <tt-list [ttData]="itemsListBusinessViews"></tt-list>
</tt-page>
